import styled from "styled-components"


export const UtilsPage = () => {
  return (
    <StyleWrap>
      UtilsPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;